import React from "react";
import "./index.css";

export default function MyStatistic({ title, value, suffix }) {
  return (
    <div className="s-content">
      <div className="stt-title">{title}</div>
      <div className="stt-value">
        {value}
        {suffix ? suffix : ""}
      </div>
    </div>
  );
}
